import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { Capacitor } from '@capacitor/core';

const isNative = Capacitor.isNativePlatform();

/**
 * Saves sensitive data to secure storage (native) or localStorage (web)
 * @param key - Storage key
 * @param value - Value to store
 */
export const saveSensitiveData = async (key: string, value: string): Promise<void> => {
  if (isNative) {
    await SecureStoragePlugin.set({ key, value });
  } else {
    localStorage.setItem(key, value);
  }
};

/**
 * Retrieves sensitive data from secure storage (native) or localStorage (web)
 * @param key - Storage key
 * @returns The stored value or null if not found
 */
export const getSensitiveData = async (key: string): Promise<string | null> => {
  if (isNative) {
    try {
      const { value } = await SecureStoragePlugin.get({ key });
      return value;
    } catch (error) {
      // Key doesn't exist
      return null;
    }
  } else {
    return localStorage.getItem(key);
  }
};

/**
 * Removes an item from secure storage (native) or localStorage (web)
 * @param key - Storage key
 */
export const removeSensitiveData = async (key: string): Promise<void> => {
  if (isNative) {
    try {
      await SecureStoragePlugin.remove({ key });
    } catch (error) {
      // Key doesn't exist, ignore error
    }
  } else {
    localStorage.removeItem(key);
  }
};

export const clearAllData = async (): Promise<void> => {
  if (isNative) {
    try {
      await SecureStoragePlugin.clear();
    } catch (error) {
      console.error('Error clearing secure storage:', error);
    }
  } else {
    localStorage.clear();
  }
};